import { AfterViewInit, Directive, HostListener, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ResolutionBreakpoints, Signs } from '../classes/ResolutionBreakpoints';

@Directive({
	selector: '[atScreenResolution]'
})
export class AtScreenResolutionDirective implements AfterViewInit, OnInit {

	@Input() atScreenResolution! : string;

	private resolution! : number;
	private sign! : string;
	
	constructor(private viewRef:ViewContainerRef,
				private templateRef:TemplateRef<any>) {
	}

	@HostListener('window:resize', ['$event']) set (event:any){
		this.do();
	}

	ngOnInit(): void {
		let s = this.atScreenResolution.split(" ");
		this.sign = s[0];
		this.resolution = parseInt(s[1]);
		if (!Signs.includes(this.sign) || !ResolutionBreakpoints.includes(this.resolution)) {
			throw new Error("Invalid argument on directive atScreenResolution.\n\nAllowed resolution breakpoints: 600, 960, 1280, 1920\nAllowed logical operators: >, <, >=, <=\n\nFormat: \"sign resolution\", with a space in between\nExample: \">= 960\" to render something only when screen width is at 960px or greater\n.");
		}
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.do();
		}, 0);
	}

	private do() {
		let b : boolean;
		switch (this.sign) {
			case "<" :
				b = (window.innerWidth < this.resolution);
				break;
			case ">" :
				b = (window.innerWidth > this.resolution);
				break;
			case ">=" :
				b = (window.innerWidth >= this.resolution);
				break;
			case "<=" :
				b = (window.innerWidth <= this.resolution);
		}

		if (b!) {
			if (this.viewRef.length == 0)
				this.viewRef.createEmbeddedView(this.templateRef);
		} else {
			this.viewRef.clear();
		}
	}
}